<template>
  <div>
    <comlistd class="op_o1" :config="listconfig" ref="listDom">
      <template v-slot:topBtn>
        <el-button
          class="feature-item add"
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addFn()"
          >新建banner</el-button
        >
        <el-button 
            class="feature-item add" 
            type="primary" 
            size="small"  
            @click="go()">返回</el-button>
        
      </template>
      <template v-slot:default="data">
        <com-list
          class="op_o2"
          v-for="(item, index) in data"
          :key="index"
          :objk="item"
          :moreBtn="moreBtn"
        >
          <template v-slot:default="data2">
            <div class="layout" v-html="clysfn(data2)"></div>
          </template>
        </com-list>
      </template>
    </comlistd>
    <el-dialog
      title="上线设置"
      class="dialog-box"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-radio-group class="art-radio-group" v-model="radio1" size="small">
        <el-radio-button label="1">
          <span @click="setFn(1)">永久上架</span>
        </el-radio-button>
        <el-radio-button label="2">
          <span @click="setFn(2)">上架时间段</span>
        </el-radio-button>
      </el-radio-group>
      <el-date-picker
        v-show="radio1 === 2"
        v-model="value1"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        placeholder="请选择上线时间段；超过时间段将自动下线"
      >
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">关 闭</el-button>
        <el-button size="small" type="primary" @click="onlineConfirm(savData)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import comlistd from "./comlist.vue";
import comList from "./com_list.vue";
export default {
  components: {
    comList,
    comlistd,
  },
  data() {
    return {
      dialogVisible: false,
      radio1: 1,
      value1: [],
      savData: {},
      listconfig: {
        url: "getBannerList",
        filterForm: [
          {
            prop: "id",
            label: "bannerID",
            pl: "请输入bannerID检索",
            type: "text",
          },
          {
            prop: "title",
            label: "banner名称",
            pl: "请输入banner名称检索",
            type: "text",
          },
          {
            prop: "sort_type",
            label: "排序权重",
            pl: "请选择排序权重检索",
            type: "select",
            option: [
              { label: "倒序", value: "1" },
              { label: "正序", value: "2" },
            ],
          },
          {
            prop: "status",
            label: "上线状态",
            pl: "请选择上线状态检索",
            type: "select",
            option: [
              { label: "上线", value: "1" },
              { label: "待上线", value: "0" },
              { label: "下线", value: "-1" },
            ],
          },
        ],
      },
      drawer: false,
      loding: false,
      form: {},

      moreBtn: {
        list: [],
        backFn: (da) => {
          let arr = [
            { label: "查看", clickFn: this.seeFn },
            { label: "编辑", clickFn: this.editFn },
            { label: "删除", clickFn: this.deletFn },
          ];
          if (da.status == -1) {
            arr.push({ label: "上线", clickFn: this.upFn });
          }
          if (da.status == 1) {
            arr.push({ label: "下线", clickFn: this.downFn });
          }
          if (da.status == 0) {
            arr.push({ label: "上线", clickFn: this.upFn });
          }
          return arr;
        },
      },
    };
  },
  mounted() {},
  // 方法集合
  methods: {
    go(){
			this.$router.push('/art/item-channel')
		},
    setFn(n) {
      this.radio1 = n;
    },
    clysfn(da) {
      if (da.data.prev_url.search(".mp4") == -1) {
        return `<img src="${da.data.prev_url}" />`;
      } else {
        return `<video src="${da.data.prev_url}"></video>`;
      }
    },

    handleClose() {
      this.dialogVisible = false;
    },
    seeFn(da) {
      this.$router.push(`/art/item5-addBanner?id=${da.id}&type=look`);
    },
    editFn(da) {
      this.$router.push(`/art/item5-addBanner?id=${da.id}&type=edit`);
    },
    deletFn(da) {
      this.delAdPosition(da);
    },
    upFn(da) {
      this.savData = da;
      this.dialogVisible = true;
    },
    downFn(da) {
      this.$confirm(`确定要下线该内容?`, "提示", {
        confirmButtonText: "确定下线",
        cancelButtonText: "取消",
        type: "warning",
        dangerouslyUseHTMLString: true,
      }).then(() => {
        let data = {
          id: da.id,
          type: "-1",
        };
        this.shelveExhibition(data);
      });
    },
    onlineConfirm(da) {
      let data = {
        type: this.radio1,
        id: da.id,
      };
      if (this.radio1 == 2) {
        data.start_time = this.value1[0];
        data.end_time = this.value1[1];
      }
      this.shelveExhibition(data);
    },

    shelveExhibition(item) {
      this.api.shelveBanner(item).then((res) => {
        if (!res) return;
        this.$message(res);
        this.getData();
        this.handleClose();
      });
    },
    getData() {
      this.$refs.listDom.getData();
    },

    delAdPosition(item) {
      this.$confirm(
        `确定要删除名称为 <span style="color:red">${item.title}</span> 的展示位吗?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      ).then(() => {
        let data = {
          id: item.id,
        };
        this.api.delBanner(data).then((res) => {
          if (!res) return;
          this.getData();
        });
      });
    },
    addFn() {
      this.$router.push("/art/item5-addBanner?type=add");
    },
  },
};
</script>
<style  lang='scss'>
.op_o1 {
  ul {
    display: flex;
    flex-flow: row wrap;
    li {
      width: 13.5%;
      margin: 0 15px 15px 0;
    }
  }
  .layout {
    display: block;
    width: 135px;
    height: 75px;
  }
  .layout > img,
  video {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>

<style>
.ys_001 {
  color: #2dc72d;
}
.ys_002 {
  color: #d1d1d1;
}
.ys_003 {
  color: #ff0000;
}
</style>
